import { Component, OnInit, Input, HostListener, ViewChild } from '@angular/core';
import { FormArray, ReactiveFormsModule, FormsModule, Validators } from '@angular/forms';
import { ApprovalsService, DataService, UserService, OperationsService } from '../../_services/index';
import { AuthenticationService, StorageService, AnalyticsService } from '../../_services/index';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
@Component({
  selector: 'app-portfoliotrends',
  templateUrl: './portfoliotrends.component.html',
  styleUrls: ['./portfoliotrends.component.css']
})
export class PortfoliotrendsComponent implements OnInit {
  single_view = false;
  chart_type = 'compare';
  is_amount = true;
  simple_trend = {
    'primary_filter': '',
    'secondary_filter': '',
    'tertiary_filter': '',
  };
  filter_one = {
    'primary_filter': '',
    'secondary_filter': '',
    'tertiary_filter': '',
  };
  filter_two = {
    'primary_filter': '',
    'secondary_filter': '',
    'tertiary_filter': '',
  };
  public barChartOptions: any = {
    scaleShowVerticalLines: false,
    responsive: true
  };
  public barChartLabels: string[] = ['2006', '2007', '2008', '2009', '2010', '2011', '2012'];
  public barChartType: string = 'bar';
  public barChartLegend: boolean = true;

  public barChartData: any[] = [
    { data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], label: 'Booked' },
    { data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], label: 'Collected' }
  ];
  public bar_categories = [
    {
      'display': '--select--',
      'value': '0'
    },
    {
      'display': 'Booked / Collected',
      'value': '1'
    },
    {
      'display': 'Collections / Due',
      'value': '2'
    }
    ,
    {
      'display': 'Disbursed / Repaid',
      'value': '3'
    },
    {
      'display': 'Repayment Analysis',
      'value': '4'
    },
    {
      'display': 'Tenure Analysis',
      'value': '5'
    }
    ,
    {
      'display': 'Loan Revenue',
      'value': '6'
    }
  ];
  bar_form = {
    BAR_CATEGORY: this.bar_categories[1],
    BAR_STYLE: '0'
  }
  loading = false;
  tertiary_filter_one: any;
  tertiary_filter_two: any;
  tertiary_filter_three: any;
  currentUser: any;
  platform_analysis: any;
  public pie_report_subcategories = [
    {
      'display': 'Total Booked',
      'value': '1'
    },
    {
      'display': 'Total Due',
      'value': '2'
    }
    ,
    {
      'display': 'Total Penalty',
      'value': '3'
    },
    {
      'display': 'Early Repayment',
      'value': '4'
    },
    {
      'display': 'Late Repayments',
      'value': '5'
    }
    ,
    {
      'display': 'Total Collected',
      'value': '6'
    },
    {
      'display': 'Average Tenor',
      'value': '7'
    },
    {
      'display': 'Average Principal',
      'value': '8'
    },
    {
      'display': 'Average Interest',
      'value': '9'
    }
  ];
  constructor(public analytics: AnalyticsService, public approvalService: ApprovalsService, public DataService: DataService,
    public router: Router, public fb: FormBuilder, public operationsService: OperationsService, public authService: AuthenticationService,
    public storageService: StorageService) {
    this.currentUser = this.storageService.read<any>('currentUser');
  }
  onSwitched(){

  }
  onCategoryChange(){

  }
  ngOnInit() {
    this.runPlatformAnalysis();
  }
  public chartClicked(e: any): void {
    //console.log(e);
  }

  public chartHovered(e: any): void {
    //console.log(e);
  }
  runPlatformAnalysis() {
    this.barChartLabels = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec']
    this.loading = true;
    this.analytics.runPlatformAnalysis(this.currentUser.token, this.bar_form)
      .subscribe(platform_analysis => {
        this.loading = false;
        this.barChartData = JSON.parse(JSON.stringify(platform_analysis.data));

      });
  }
getSimpleSummary() {
  this.barChartLabels = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];
  this.loading = true;
    this.analytics.getSimplePortfolioSummary(this.currentUser.token, this.simple_trend, this.is_amount).subscribe(res => {
      this.loading = false;
      this.barChartData = JSON.parse(JSON.stringify(res.result));
    }, err => {
      //console.log(err);
    });
}
  populateTertiaryFilter(type) {
    this.loading = true;
    let secondary_filter = this.simple_trend.secondary_filter;
    if (type == 'two') {
      secondary_filter = this.filter_one.secondary_filter;
    }
    if (type == 'three') {
      secondary_filter = this.filter_two.secondary_filter;
    }
    this.analytics.populateTertiaryFilter(this.currentUser.token, secondary_filter)
      .subscribe(data => {
        this.loading = false;
        if (type == 'one') {
          this.tertiary_filter_one = data.data;
        }
        if (type == 'two') {
          this.tertiary_filter_two = data.data;
        }
        if (type == 'three') {
          this.tertiary_filter_three = data.data;
        }

      });
  }
  getComparisonSummary() {
    this.barChartLabels = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];
    this.loading = true;
    this.analytics.getComparisonPortfolioSummary(this.currentUser.token, this.filter_one, this.filter_two, this.is_amount)
      .subscribe(platform_analysis => {
        this.loading = false;
        this.barChartData = JSON.parse(JSON.stringify(platform_analysis.data));

      });
  }
}
